import { UPDATE_TODAYS_INTAKE, UPDATE_INTAKE, UPDATE_INTAKE_HISTORY } from "../actions/actionTypes";

const initalState = {
  todays_intake: [],
  intake: {},
  intake_history: [],
};

const nutritionReducer = (state = initalState, action) => {
  switch (action.type) {
    case UPDATE_TODAYS_INTAKE:
      return {
        ...state,
        todays_intake: action.payload,
      };
    case UPDATE_INTAKE:
      return {
        ...state,
        intake: action.payload,
      };
    case UPDATE_INTAKE_HISTORY:
      return {
        ...state,
        intake_history: action.payload,
      };
    default:
      return state;
  }
};

export default nutritionReducer;
